import { Box, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { SttDialog } from '../../../sporttia/dialogs/SttDialog';

export default function ModalGotoSc({ rate, scContactInfo, onClose }: any) {
    const { t } = useTranslation();

    return (
        <SttDialog
            open={rate !== null}
            onClose={onClose}
            title={t('activity.inscription')}
            content={
                <>
                    <Box mb={3}>
                        <Typography>{t('activity.goToSC')}</Typography>
                    </Box>
                    <Box>
                        <Typography>
                            <span>{t('labels.phone')}:</span>&nbsp;
                            <b>{scContactInfo.phone}</b>
                        </Typography>
                        <Typography>
                            <span>{t('labels.email')}:</span>&nbsp;
                            <b>{scContactInfo.email}</b>
                        </Typography>
                    </Box>
                </>
            }
        />
    );
}
